import React, { Component } from 'react'

export default class Navbar extends Component {
  render() {
    return (
      <div className="col-lg-3 col-md-12 col-sm-12 col-12 col-psre-1 d-lg-block d-md-none d-sm-none d-none">
        <ul className="navbar-nav nav-apa">
          <li className="nav-item">
            <a className="nav-link perkenalan" href="#sebuah-perkenalan">Sebuah Perkenalan</a>
          </li>
          <li className="nav-item">
            <a className="nav-link psre-induk" href="#psre-induk-dan-psre-berinduk">PSrE Induk dan PSrE Berinduk</a>
          </li>
          <li className="nav-item">
            <a className="nav-link peraturan" href="#peraturan-dan-ketentuan-menjadi-psre-berinduk">Peraturan & Ketentuan Menjadi PSrE Berinduk</a>
          </li>
          <li className="nav-item">
            <a className="nav-link kewajiban" href="#kewajiban-psre-induk">9 Kewajiban PSrE Induk</a>
          </li>
          <li className="nav-item">
            <a className="nav-link kewenangan" href="#kewenangan-psre-induk">6 Kewenangan PSrE Induk</a>
          </li>
          <li className="nav-item">
            <a className="nav-link pendaftaran" href="#proses-pendaftaran-sertifikat-elektronik">Proses Pendaftaran Sertifikat Elektronik</a>
          </li>
          <li className="nav-item">
            <a className="nav-link hak-pemilik" href="#hak-dan-kewajiban-pemilik-sertifikat-elektronik">Hak dan Kewajiban Pemilik Sertifikat Elektronik</a>
          </li>
          <li className="nav-item">
            <a className="nav-link lain" href="#lain-lainnya">Lain - Lainnya</a>
          </li>
        </ul>
      </div>
    )
  }
}
